import React, { useEffect, useState } from "react";
import { getPublishingProblems } from "./verification";

export default function ContentVerification({
  content,
  destination,
}: {
  content: (Content | undefined)[];
  destination?: Destination;
}) {
  const [result, setResult] = useState([[], []]);
  const [problems, warnings] = result;

  useEffect(() => {
    async function verify() {
      if (destination && content) {
        getPublishingProblems(destination, content).then(setResult);
      }
    }
    verify();
  }, [content.length, destination?.id]);

  return (
    <>
      {problems.map((problem, i) => (
        <div className="problem" key={i}>
          {problem}
        </div>
      ))}
      {warnings.map((warning, i) => (
        <small className="op08 fz08 block warning" key={i}>
          {warning}
        </small>
      ))}
    </>
  );
}
